export const ADVENTURE_DETAILS_MODAL = 'ADVENTURE_DETAILS_MODAL';
export const GUIDES_MODAL = 'GUIDES_MODAL';

export const VALIDATOR_REQUIRED = 'VALIDATOR_REQUIRED';
export const VALIDATOR_STRING_NOT_EMPTY = 'VALIDATOR_STRING_NOT_EMPTY';
export const VALIDATOR_IS_NUMBER = 'VALIDATOR_IS_NUMBER';
export const VALIDATOR_IS_EMAIL = 'VALIDATOR_IS_EMAIL';
